import { Download } from "lucide-react";
import "./Settings.scss";
import { useDb } from "@/database/provider/useDb";

export const Settings = () => {
    const db = useDb();
    async function dumpDb() {
        try {
            const file = await db.$client.dumpDataDir("gzip");
            const url = URL.createObjectURL(file);
            const a = document.createElement("a");
            a.href = url;
            a.download = "pglite-dump.tar.gz";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
        catch (err) {
            console.error("Error dumping database:", err);
        }
    }
    return <section className="settings">
        <div className="settings__section">
            <h3>Export Database</h3>
            <hr />
            <div className="settings__section-content">
                <p>Exports pglite database as .gzip file</p>
                <button className="settings__primary-button" onClick={dumpDb}>
                    <Download width={18} height={18} />Download
                </button>
            </div>
        </div>
    </section>
}